export const getInitialState = (): any => ({
  snowflakeDataPushStatusData: {},
  snowflakeDataPushStatus: 0
});